import { FaThumbsUp } from 'react-icons/fa';
import { REQUIRED_DOC_LIST } from '../../../constants/settings';
import RequiredDocDiv from '../../ApplicationDocComps/RequiredDocDiv';
import AcademiaButton from '../Buttons/AcademiaButton';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const DocUploadInstructionModal = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  // rendering document upload instruction modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='Document upload instructions' />

      <div>
        <p className='text-center md:text-left text-legal-dark-blue !mt-1 md:!mt-0'>
          In order to complete the application process. You need to upload some
          necessary documents mentioned below. Or else, your application might
          be <span className='font-semibold text-base-red'>rejected</span> by
          admin.
        </p>

        <div className='space-y-2 !mt-2 border-2 border-dashed border-legal-dark-blue px-2 py-1 rounded-lg'>
          {REQUIRED_DOC_LIST.map((doc, index) => (
            <RequiredDocDiv
              key={index}
              docTitle={doc.doc_title}
              docDescription={doc.doc_description}
            />
          ))}
        </div>

        <div className='mt-5'>
          <AcademiaButton
            type='button'
            onClick={handleModalClose}
            variant='premium'
            icon={<FaThumbsUp className='size-5' />}
            fullWidth
          >
            Okay, I Understood
          </AcademiaButton>
        </div>
      </div>
    </ParentModal>
  );
};

export default DocUploadInstructionModal;
